/* eslint-disable */
export enum ApiEndpoints {
  editionStage = 'public/child-choice-path/edition-stage',
  counters = 'public/child-choice-path/counters',
  consent = 'public/resource/consent-form/:consentName'
}
